import { FIT_FINDER_HASH } from '@consts/index'
import useHashRouter from '@helpers/hooks/useHashRouter'

export function useFitFinderToggle() {
  const { hash, addHash, removeHash } = useHashRouter()
  const isFitFinderOpen = hash === FIT_FINDER_HASH

  const openFitFinder = () => {
    addHash(FIT_FINDER_HASH)
  }

  return {
    isFitFinderOpen,
    openFitFinder,
    closeFitFinder: removeHash
  }
}
